import React from "react";
import { objToFormData } from "../../../helpers/FormHelper";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { createAsset } from "../../../actions/community/assetsActions";
import { setNewParams, setNewError } from "../../../store/community/assetsSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const dispatch = useAppDispatch();
  const newParams = useAppSelector(state => state.community.assets.newParams);
  const error = useAppSelector(state => state.community.assets.newError);

  let params: any = { ...newParams };

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(rawData: any) {
    const data = { ...rawData };
    delete data.moment_date;

    data.published_at = rawData.moment_date.toString();

    const rules     = {};
    const formData  = objToFormData(data, rules);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createAsset(data));

    if (createAsset.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!newParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-skin'>
        <h6 className="v-content-label">Create Asset</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
